import { createFrontendModule } from '@backstage/frontend-plugin-api';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

// Pages and tabs that are for Platform Engineers (Admin DevOps), not for developers. They are
// removed from the app for anyone the permission policy denies `scaffolder.template.management`
// (demoTemplatePolicy.ts denies it to everyone outside Admin DevOps), so there is no dead link
// or tab to click. The backend policy stays the real gate; this only hides what would be denied.
const adminOnly = {
  if: { permissions: { $contains: 'scaffolder.template.management' } },
};

const extensions = [
  // Scaffolder tabs: template editor, installed actions, templating extensions. The Tasks tab
  // stays: it lists the user's own provisioning runs.
  scaffolderPlugin.getExtension('sub-page:scaffolder/editor').override(adminOnly),
  scaffolderPlugin.getExtension('sub-page:scaffolder/actions').override(adminOnly),
  scaffolderPlugin
    .getExtension('sub-page:scaffolder/templating-extensions')
    .override(adminOnly),
  // Register Existing Component (catalog write is admin-only on the backend).
  catalogImportPlugin.getExtension('page:catalog-import').override(adminOnly),
  // Developer-facing diagnostics of the app's extension tree.
  appVisualizerPlugin.getExtension('page:app-visualizer').override(adminOnly),
  // Settings > Feature Flags: this portal has no user-toggleable flags, so only platform engineers get the tab.
  userSettingsPlugin.getExtension('sub-page:user-settings/feature-flags').override(adminOnly),
];

export const adminOnlyModules = [
  createFrontendModule({ pluginId: 'scaffolder', extensions: extensions.slice(0, 3) }),
  createFrontendModule({ pluginId: 'catalog-import', extensions: [extensions[3]] }),
  createFrontendModule({ pluginId: 'app-visualizer', extensions: [extensions[4]] }),
  createFrontendModule({ pluginId: 'user-settings', extensions: [extensions[5]] }),
];
